import React, { useContext } from 'react'
import { QuranAudios } from '../data/Audios'
import { FontAwesome } from '../data/FontAwesome';
import { AppContext } from '../AppContext';

export default function Recitations() {

    const { reciteQuranAudio, showMsg, t, isRtl } = useContext(AppContext)
    const reciterName = t('recitations.reciterMaher')
    const getSurahName = (q) => t('recitations.surahs.' + q.id) || q.name

    return (
        <div className='recitations-panel'>

            <div className='recitations-hero'>
                <span className='recitations-hero-mark' aria-hidden='true'>{FontAwesome.Book}</span>
                <span className='recitations-hero-copy'>
                    <strong>{t('recitations.title')}</strong>
                    <small>{t('recitations.collectionHint')}</small>
                </span>
                <span className='recitations-count'>{t('recitations.surahCount').replace('{count}', QuranAudios.length)}</span>
            </div>

            <div className='recitations-reciter'>
                <span>{t('recitations.featuredReciter')}</span>
                <strong>{reciterName}</strong>
            </div>

            <div className='recitations-list'>
                {QuranAudios.map((q) => (<button key={'Q' + q.id} type='button'
                    className='recitation-card' onClick={() => {
                    reciteQuranAudio(q.id);
                    showMsg(t('recitations.startMsg').replace('{reciter}', reciterName));
                    document.activeElement.blur();
                }}>
                    <span className='recitation-play'>{FontAwesome.Play}</span>
                    <span title={`${t('recitations.surahPrefix')} ${getSurahName(q)}`} className={'recitation-meta ' + (isRtl ? 'text-end' : 'text-start')}>
                        <strong>{t('recitations.surahPrefix')} {getSurahName(q)}</strong>
                        <small>{t('recitations.playSurah')}</small>
                    </span>
                    <span className='recitation-id'><small>{t('recitations.surahNumber')}</small>{Number(q.id)}</span>

                </button>))}
            </div>

            <a href="https://mp3quran.net/eng/maher" className='recitation-source' target="_blank" rel="noreferrer"><b>{t('recitations.source')}</b></a>

        </div>
    )
}
